// extracted by mini-css-extract-plugin
export default {"link":"HeaderLink_link__4-WB0","pill":"HeaderLink_pill__0THlY","alert":"HeaderLink_alert__opzAv","pillText":"HeaderLink_pillText__dr33M"};